import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
export default (function (InnerComponent) {
  // eslint-disable-next-line @repo/internal/react/no-class-components
  var EngagementEventsWrapper = /*#__PURE__*/function (_Component) {
    _inherits(EngagementEventsWrapper, _Component);
    var _super = _createSuper(EngagementEventsWrapper);
    function EngagementEventsWrapper() {
      var _this;
      _classCallCheck(this, EngagementEventsWrapper);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "fireClickEvent", function (clickType) {
        _this.fireEvent('click', {
          clickType: clickType
        });
      });
      return _this;
    }
    _createClass(EngagementEventsWrapper, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this.fireEvent('shown');
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.fireEvent('hidden');
      }
    }, {
      key: "fireEvent",
      value: function fireEvent(action) {
        var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _this$props = this.props,
          createAnalyticsEvent = _this$props.createAnalyticsEvent,
          messageId = _this$props.messageId,
          variationId = _this$props.variationId,
          componentId = _this$props.componentId,
          componentType = _this$props.componentType,
          isLast = _this$props.isLast;
        var analyticsEvent = createAnalyticsEvent(_objectSpread({
          action: action
        }, properties));
        analyticsEvent.update({
          ekMessageId: messageId,
          ekVariationId: variationId,
          ekComponentId: componentId,
          ekComponentType: componentType,
          ekIsLast: isLast
        });
        analyticsEvent.fire('engagement');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(InnerComponent, _extends({}, this.props, {
          fireClickEvent: this.fireClickEvent
        }));
      }
    }]);
    return EngagementEventsWrapper;
  }(Component);
  return withAnalyticsEvents()(EngagementEventsWrapper);
});